export default __webpack_public_path__ + "static/media/project10.278c72fa.webp";